
export function fmtDaysHrsMinFromISODateRange(iso8601String1, iso8601String2, precision='m') {
  var date1=new Date(iso8601String1);
  var date2=new Date(iso8601String2);
  return fmtDaysHrsMinFromMillis(Math.abs(date2 - date1), precision);
}

export function fmtDaysHrsMinFromMins(minutes, precision='m') {
  return fmtDaysHrsMinFromMillis(minutes*60000, precision);
}

export function fmtDaysHrsMinFromSecs(seconds, precision='m') {
  return fmtDaysHrsMinFromMillis(seconds*1000, precision);
}

export function fmtDaysHrsMinFromMillis(millis, dhms, compact=true) {

  var precision = dhms;
  if(!['d', 'h', 'm', 's'].includes(dhms)) {
    precision='m';
  }
  var cd = 24 * 60 * 60 * 1000,
        ch = 60 * 60 * 1000,
        d = precision==='d'?Math.round(millis / cd):Math.floor(millis / cd),
        h = precision==='h'?Math.round( (millis - d * cd) / ch):Math.floor( (millis - d * cd) / ch),
        m = precision==='m'?Math.round( (millis - d * cd - h * ch) / 60000):Math.floor( (millis - d * cd - h * ch) / 60000),
        s = Math.round( (millis - d * cd - h * ch - m * 60000) / 1000);
  if( s === 60 ){
    m++;
    s = 0;
  }
  if( m === 60 ){
    h++;
    m = 0;
  }
  if( h === 24 ){
    d++;
    h = 0;
  }
  let parts=[];
  if(d>0) {
    parts.push(d+(compact?"d":" day"+(d===1?'':'s')));
  }
  if(d>10) return parts.join(' ');
  if(h>0 && ['h', 'm', 's'].indexOf(precision) >= 0) {parts.push(h+(compact?"h":" hr"+(h===1?'':'s')))}
  if(h>10) return parts.join(' ');
  if(m>0 && ['m', 's'].indexOf(precision) >= 0) {parts.push(m+(compact?"m":" min"+(m===1?'':'s')))}
  if(m>10) return parts.join(' ');
  if(s>0 && ['s'].indexOf(precision) >= 0) {parts.push(s+(compact?"s":" sec"+(m===1?'':'s')))}
  if(parts.length>0) {
    return parts.join(' ');
  } else {
    return "<1"+(compact?precision:(precision==='d'?" day":(precision==='h'?" hour":(precision==='m'?" min":" sec"))));
  }
}
